﻿import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsLoading(true);

    const result = await forgotPassword(email);
    setIsLoading(false);

    if (result.success) {
      setSuccess(true);
    } else {
      setError(result.error || 'Erro ao processar solicitação.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-portal-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-portal-purple rounded-xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-check-line text-white text-3xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-portal-gray-900">
            Portal do Colaborador
          </h1>
          <p className="text-sm text-portal-gray-500 mt-1">
            Segurança do Trabalho
          </p>
        </div>

        <div className="bg-white rounded-xl border border-portal-gray-200 p-8 shadow-sm">
          <h2 className="text-lg font-semibold text-portal-gray-800 mb-2">
            Recuperar senha
          </h2>
          <p className="text-sm text-portal-gray-500 mb-6">
            Informe seu e-mail. Você receberá instruções para redefinir sua senha.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">
              Se o e-mail estiver cadastrado, você receberá instruções em breve.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="email" className="block text-sm font-medium text-portal-gray-700 mb-1.5">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Digite seu e-mail"
                className="w-full px-3.5 py-2.5 border border-portal-gray-300 rounded-lg text-sm text-portal-gray-800 placeholder-portal-gray-400 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple transition-colors"
                autoComplete="email"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-portal-purple hover:bg-portal-purple-dark text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Enviando...' : 'Enviar instruções'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-portal-purple hover:text-portal-purple-dark font-medium transition-colors"
            >
              Voltar para o login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
